import type { ReactNode } from "react";
import Breadcrumb, { type Crumb } from "@/components/base/Breadcrumb";

interface PageHeroProps {
  title: string;
  subtitle?: string;
  crumbs?: Crumb[];
  image?: string;
  children?: ReactNode;
}

export default function PageHero({ title, subtitle, crumbs, image, children }: PageHeroProps) {
  return (
    <section className="relative overflow-hidden border-b border-background-800 bg-background-900">
      {image && (
        <>
          <img
            src={image}
            alt=""
            aria-hidden="true"
            className="absolute inset-0 h-full w-full object-cover object-top opacity-25"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-background-950 via-background-950/85 to-background-950/50"></div>
        </>
      )}
      <div className="relative mx-auto w-full px-4 py-10 md:px-6 md:py-14">
        {crumbs && <Breadcrumb items={crumbs} />}
        <h1 className="mt-4 max-w-3xl font-heading text-2xl font-bold text-foreground-50 md:text-4xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-400 md:text-base">
            {subtitle}
          </p>
        )}
        {children && <div className="mt-6">{children}</div>}
      </div>
    </section>
  );
}